import request from '@/utils/request'

// 直送材料叫料管理列表
export function apiScpDirectDeliveryCallManager (data) {
  return request({
    url: '/scp/scpDirectDeliveryCallManager/page',
    method: 'post',
    data: data
  })
}

// 更新叫料数据
export function apiCallManagerUpdateCallData (data) {
  return request({
    url: `/scp/scpDirectDeliveryCallManager/updateCallData`,
    method: 'post',
    data: data
  })
}

// 更新叫料数据状态
export function apiCallManagerUpdateStatus (data) {
  return request({
    url: `/scp/scpDirectDeliveryCallManager/updateStatus`,
    method: 'post',
    data: data
  })
}

// 导出直送材料叫料列表
export function apiExportDirectDeliveryCaLL (data) {
  return request({
    url: `/scp/scpDirectDeliveryCallManager/exportDirectDeliveryCaLL`,
    method: 'post',
    data: data
  })
}

// 导出叫料通知
export function apiMaterialExportCallNotice (data) {
  return request({
    url: '/scp/scpDirectDeliveryCallManager/exportCallNotice',
    method: 'post',
    data: data
  })
}

// 下推叫料通知
export function apiMaterialPushCallNotice (data) {
  return request({
    url: '/scp/scpDirectDeliveryCallManager/pushCallNotice',
    method: 'post',
    data: data
  })
}

// 复制行保存
export function apiSaveCopyCallNotice (data) {
  return request({
    url: `/scp/scpDirectDeliveryCallManager/copyCallNotice`,
    method: 'post',
    data: data
  })
}

// 刷新可叫料数
export function apiRefreshCanCallQty (data) {
  return request({
    url: `/scp/scpDirectDeliveryCallManager/refreshCanCallQty`,
    method: 'post',
    data: data
  })
}

// 更新直送材料叫料通知
export function apiUpdateDirectDeliveryCallNotice (data) {
  return request({
    url: `/scp/scpDirectDeliveryCallManager/updateDirectDeliveryCallNotice`,
    method: 'post',
    data: data
  })
}

// 叫料通知列表
export function apiGetCallNoticeList (data) {
  return request({
    url: '/scp/scpDirectDeliveryCallManager/getCallNoticeList',
    method: 'post',
    data: data
  })
}

// 清空并保存直送材料叫料通知
export function apiClearSaveCallNotify (data) {
  return request({
    url: '/scp/scpDirectDeliveryCallManager/clearSaveCallNotify',
    method: 'post',
    data: data
  })
}

// 取消叫料
export function apiCallManagerCancelCall (data) {
  return request({
    url: '/scp/scpDirectDeliveryCallManager/cancelCall',
    method: 'post',
    data: data
  })
}

// 刷新可叫料数(虚拟仓)
export function apiRefreshCanCallQtyVirtual (data) {
  return request({
    url: '/scp/scpDirectDeliveryCallManager/refreshCanCallQtyVirtual',
    method: 'post',
    data: data
  })
}
